<div class="login form-frame">
  <app-logo />

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">
    <h2
      class="form-frame__body-title">
      {{'LOGIN_PAGE.LOGIN_TITLE' | translate}}
    </h2>
    <p
      class="form-frame__body-description">
      {{'LOGIN_PAGE.LOGIN_DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">

      <div
        [class.error]="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched"
        class="input-block">
        <input
          formControlName="emailFormControl"
          id="mail"
          class="input"
          type="email"
          placeholder=" ">
        <label
          for="mail"
          class="placeholder">
          {{'LOGIN_PAGE.E_MAIL' | translate}}
        </label>
        <ng-container *ngIf="form.get('emailFormControl')?.invalid && form.get('emailFormControl')?.touched">
          <span
            *ngIf="emailFormatError"
            class="input-block__error">
            {{'LOGIN_PAGE.EMAIL_INVALID' | translate}}
          </span>
          <span
            *ngIf="emailRequiredError"
            class="input-block__error">
            {{'LOGIN_PAGE.EMAIL_REQUIRED' | translate}}
          </span>
        </ng-container>
      </div>

      <div
        [class.error]="form.get('passwordFormControl')?.invalid && form.get('passwordFormControl')?.touched"
        class="input-block">
        <input
          formControlName="passwordFormControl"
          id="password"
          class="input"
          type="{{inputPasswordType}}"
          placeholder=" ">
        <a
          routerLink="/recovery-password"
          class="input-block__recovery-password">
          {{'LOGIN_PAGE.FORGOT' | translate}}
        </a>
        <label
          for="password"
          class="placeholder">
          {{'LOGIN_PAGE.PASSWORD' | translate}}
        </label>
        <button
          [class.active]="isVisible"
          (click)="visibilityPassword()"
          type="button"
          class="input-block__visibility-btn">
        </button>
        <ng-container *ngIf="form.get('passwordFormControl')?.invalid && form.get('passwordFormControl')?.touched">
          <span
            *ngIf="passwordRequiredError"
            class="input-block__error">
            {{'LOGIN_PAGE.PASSWORD_REQUIRED' | translate}}
          </span>
        </ng-container>
      </div>

      <label class="checkbox">
        <input
          [checked]="saveUser"
          (change)="saveUser = !saveUser"
          type="checkbox"
          class="checkbox__input checkboxItem">
        <span class="checkbox__icon"></span>
        <span
          class="checkbox__name">
          {{'LOGIN_PAGE.SAVE_USER' | translate}}
        </span>
      </label>

      <button
        [disabled]="form.invalid || isFormSending"
        type="submit"
        class="btn btn-accent btn-send">
        {{'LOGIN_PAGE.LOGIN' | translate}}
      </button>
    </div>
  </form>

  <app-create-account />

  <app-lang-select />
</div>





